
import React, {useState, useEffect} from "react";

import axios from "axios";

import { Link, useNavigate } from 'react-router-dom';

import validator from 'validator';
import Swal from "sweetalert2";
import GoogleVerifyAuthButton from "../component/GoogleVerifyAuthButton";


axios.defaults.baseURL='https://suvivah.org/suvivah/api/';

function ForgotPasswordContent() {
    let navigate = useNavigate();

    let [email,setEmail] = useState("");
    let [user,setUser] = useState("");
    let [password,setPassword] = useState("");

    let [emailerr,setEmailerr] = useState(false);
    let [usererr,setUsererr] = useState(false);
    let [passworderr,setPassworderr] = useState(false);

    let [flagmsg,setFlagmsg]=useState(false);
    let [msg,setMsg]=useState("");
    let [msgcode,setMsgcode]=useState("");
    let [msgcolor,setMsgcolor]=useState("");
    let [btnlogin,setBtnlogin]=useState(false);

    async function loginauth() {
        var flag=1;

        
        // if (user.length<10) {
        //     setUsererr(true);
        //     flag=0;
        // }

        const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isPhone = /^\d{10}$/.test(user);
        const isEmail = EMAIL.test(user);

        if (!isPhone && !isEmail) {
            setUsererr(true);
            flag = 0;
        }

        if (password.length<6) {
            setPassworderr(true);
            flag=0;
        }

        if (flag==1) {
            var fd=new FormData();
            // fd.append("email",email);  
            fd.append("user",user);     
            fd.append("password",password);           

            try {
                var resp=await axios.post("/custlogin",fd);
                // var data=resp.data;

                if (resp.data.msgcode==1) {
                    Swal.fire({
                        icon: "success",
                        title: "Login Successful",
                        text: resp.data.msg,
                        confirmButtonColor: "#dc3545",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: true
                    }).then(() => {
                        // Redirect if required
                        localStorage.setItem("pid", resp.data.profileid);
                        navigate("/dashboard");

                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Login Failed",
                        text: resp.data.msg,
                        confirmButtonColor: "#dc3545"
                    });
                }

                

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Login Failed",
                    text: err.response?.data?.msg || "Something went wrong.",
                    confirmButtonColor: "#dc3545"
                });

            }
        }

    }

    useEffect(()=>{
        if (localStorage.getItem("pid")) {
            let path=`/dashboard`;
            navigate(path);
        }
    },[])

    return(
        <>

        
<div class="devider"></div>

<section class="login-row">
<div class="container">
    {/* <div class="row">
        <div class="col-md-12">
            <header>
                <h2 class="text-center mb-4">Login Now</h2>
            </header>
            
        </div>
    </div> */}

    {flagmsg?<div className={msgcolor}>{msg}</div>:''}

    <div className="container py-3">
        <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">

                <div className="card login-card border-0 shadow-lg rounded-4 overflow-hidden">

                    {/* Header */}
                    <div className="login-header text-center text-white py-2">
                        <i className="bi bi-person-circle display-4"></i>
                        <h3 className="fw-bold mt-2 mb-1 text-light">Forgot Your Password?</h3>
                        <p className="mb-0">Use linked Google account for verification</p>
                    </div>

                    <div className="card-body p-4">

                        {/* Phone */}
                        <div className="mb-4">
                            <label className="form-label fw-semibold">
                                Registered Mobile No / Email ID
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-phone"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    // maxLength={10}
                                    placeholder="Registered Mobile / Email Id"
                                    onChange={(ev) => {
                                        setUser(ev.target.value);
                                        const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                        const isPhone = /^\d{10}$/.test(ev.target.value);
                                        const isEmail = EMAIL.test(ev.target.value);

                                        if (isPhone || isEmail) {
                                            setUsererr(false);
                                        }
                                    }}
                                />
                            </div>

                            {usererr && (
                                <small className="text-danger">
                                    Please enter your registered 10-digit mobile number / email id.
                                </small>
                            )}
                        </div>


                        {/* Google Authentication */}
                        <div className="text-center my-4">
                            <GoogleVerifyAuthButton 
                                user={user}
                                setUsererr={setUsererr} 
                            />
                        </div>
                        {/* Google Authentication */}

                        {/* Register */}
                        <div className="text-center mt-4">
                            <small className="text-muted">
                                Already have an account?
                                <Link to="/login" className="text-danger fw-bold ms-1 text-decoration-none">
                                    Login
                                </Link>
                            </small>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>

    {/* <div class="row">
        <div class="col-md-8 offset-md-2">
                <div class="register_box">
            <div class="row mb-3">               

                <div class="col-md-12">
                    <input type="email" class="form-control" maxLength={10} id="email" placeholder="Enter Registered Phone Number" name="email" onChange={(ev)=>{
                        setPhone(ev.target.value);
                        if (ev.target.value.length==10) {
                            setPhoneerr(false);
                        }
                    }} />
                    {phoneerr?<div className='text text-danger small'>Valid Phone Number Required</div>:''}
                </div>
                
            </div>
            

            <div class="row mb-3">
                <div class="col-md-12">
                     <input type="password" class="form-control" placeholder="Enter Valid Password" name="password" onChange={(ev)=>{
                        setPassword(ev.target.value);
                        if (password.length>5) {
                            setPassworderr(false);
                        }
                     }} />
                     {passworderr?<div className='text text-danger small'>Valid Password Required</div>:''}
                </div>
                            
            </div>

            <div class="row">                
                <div class="col-md-12 text-center">
                   <button type="button" class="btn btn-red px-5 t" onClick={loginauth} disabled={btnlogin}>Login</button>
                </div>               
            </div>

            </div>
            <p class="text-center pt-2"><a href="#" class="text-black" onClick={()=>{
                alert("Coming Soon....");
            }}>Forgot Password?</a></p>
        </div>

    </div> */}
</div>
</section>




        </>
    );
}

export default ForgotPasswordContent;